import { Router } from "./routes";
import React, { useEffect } from "react";
import { AntdConfigProvider } from "./layouts";
import { BrowserRouter } from "react-router-dom";
import { NotificationProvider } from "./sharedComponents";
import { Provider } from "react-redux";
import { UserStore } from "./context/user";
import { ToastContainer } from "react-toastify";
import store from "./slices/index";

const App = () => {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <UserStore>
          <AntdConfigProvider>
            <NotificationProvider>
              <ToastContainer />
              <Router />
            </NotificationProvider>
          </AntdConfigProvider>
        </UserStore>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
